module.exports = __webpack_public_path__ + "img/menu-icon-5-3.d2388c82.svg";